<template>
  <div class="zap" :class="{ 'd-none': displayControl }">
    <button
      class="bg-transparent border-0 p-0 animated delay-1s fadeIn"
      style="top: -20px; left: 5px; z-index: 11;outline:none"
      @click="$router.push('contato-whatsapp')"
    >
      <img
        :src="require(`@/assets/icons/zap.svg`)"
        width="40"
        height="40"
        class="animated delay-2s rotateIn"
      />
    </button>
  </div>
</template>

<script>
import { VueTypedJs } from "vue-typed-js";
export default {
  data() {
    return {
      displayControl: false
    };
  }
};
</script>

<style lang="scss" scoped>
.zap {
  position: fixed;
  z-index: 3;
  bottom: 60px;
  right: 60px;
  @media screen and (max-width: 720px) {
    right: 8px;
    bottom: 67px;
  }
}
</style>